import PurchaseRequestService from '@/services/admin/PurchaseRequestService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

export const allowedFilters = ['farmer_id', 'product_name', 'created_between', 'status', 'farmer_payment_type']

export const namespaced = true

export const state = {
  purchaseRequests: null,
  purchaseRequest: {},
  meta: null
}

export const mutations = {
  SET_PURCHASE_REQUESTS(state, purchaseRequests) {
    state.purchaseRequests = purchaseRequests.data
    state.meta = purchaseRequests.meta
  },
  SET_PURCHASE_REQUEST(state, purchaseRequest) {
    state.purchaseRequest = purchaseRequest
  }
}

export const actions = {
  getPurchaseRequests({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      PurchaseRequestService.getPurchaseRequests(newQuery)
        .then(response => {
          commit('SET_PURCHASE_REQUESTS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPurchaseRequest({ commit }, id) {
    return new Promise(resolve => {
      PurchaseRequestService.getPurchaseRequest(id).then(response => {
        commit('SET_PURCHASE_REQUEST', response.data)
        resolve(response.data)
      })
    })
  }
}
